export default __webpack_public_path__ + "94459f6ba2521c50b50f25ebfd10070e.svg";